export enum ToolsEnum {
  SELECT = 'SELECT',
  BRUSH = 'BRUSH',
  IMAGE = 'IMAGE',
  LINE = 'LINE',
  RECT = 'RECT',
  ELLIPSE = 'ELLIPSE',
  TEXT = 'TEXT',
  ERASER = 'ERASER',
}
